import React from 'react';
import { overlaySelector } from '@root/store/slices/overlaySlice';
import { roundSelector } from '@root/store/slices/roundSlice';
import { useTypedSelector } from '@root/store/store';
import { useTranslation } from 'react-i18next';
import styles from './BettingPill.module.scss';

// "Betting Ends in N Sec" pill, overlaid inside GameFrame's canvas area
// (mounted there alongside PhaserOverlay) rather than
// rendered as a separate block outside the animation area.
const BettingPill: React.FC = () => {
  const { t } = useTranslation();
  const { availableToBet } = useTypedSelector(roundSelector);
  const { bettingRemainingTime } = useTypedSelector(overlaySelector);

  const show = availableToBet && Number(bettingRemainingTime) > 0;
  if (!show) return null;

  return (
    <div className={styles.root}>
      {t('Betting Ends in {{seconds}} Sec', {
        seconds: String(bettingRemainingTime).padStart(2, '0'),
      })}
    </div>
  );
};

export default BettingPill;
